export default __webpack_public_path__ + "static/media/alsmood.83cff861.png";